import React, {useState,useEffect } from 'react';

import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, TextField, MenuItem
} from '@mui/material';

const ManageUserModal = ({
  open,
  onClose,
  onConfirm,
    flag,
    initialData = {},
    dataChange,
}) => {
    const [formData, setFormData] = useState({
    FullName: initialData.FullName || '',
    FirstName: initialData.FirstName || '',
    LastName: initialData.LastName || '',
    EmailID: initialData.EmailID || '',
    UserID: initialData.UserID || '',
    NetworkID: initialData.NetworkID || '',
    AdminStatus: initialData.AdminStatus || false,
    });

    useEffect(() => {
        setFormData({
            FullName: initialData.FullName || '',
            FirstName: initialData.FirstName || '',
            LastName: initialData.LastName || '',
            EmailID: initialData.EmailID || '',
            UserID: initialData.UserID || '',
            NetworkID: initialData.NetworkID || '',
            AdminStatus: initialData.AdminStatus || false,
            AdminValue: initialData.AdminStatus ? '1' : '0',
        });
    }, [initialData]);

    console.log("formData", formData);

  return (
    <Dialog open={open} onClose={onClose}>
     <DialogTitle>Manage User Details</DialogTitle>
<DialogContent>
  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16, marginTop: 24 }}>
  <Typography variant="subtitle1" component="div" sx={{ minWidth: 120 }}>
    First Name <span style={{color: 'red'}}>*</span>
  </Typography>
  <TextField
  fullWidth
  label="Enter First Name"
  variant="outlined"
  size="small"
  value={formData.FirstName || ''}
  onChange={(e) => setFormData({ ...formData, FirstName: e.target.value })}
  sx={{
    marginLeft: 2,
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px', // Add border radius
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ec008c', // Highlight border on focus
        boxShadow: '0 0 0 2px rgba(236,0,140,0.15)', // Optional: subtle glow
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '10px', // Ensure border radius on default
    },
  }}
  required
/>
</div>
  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
    <Typography variant="subtitle1" component="div" sx={{ minWidth: 120 }}>
      Last Name  <span style={{color: 'red'}}>*</span>
    </Typography>
    <TextField
      fullWidth
      label="Enter Last Name"
      variant="outlined"
      size="small"
        value={formData.LastName || ''}  
        onChange={(e) => setFormData({ ...formData, LastName: e.target.value })}
       sx={{
    marginLeft: 2,
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px', // Add border radius
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ec008c', // Highlight border on focus
        boxShadow: '0 0 0 2px rgba(236,0,140,0.15)', // Optional: subtle glow
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '10px', // Ensure border radius on default
    },
  }}
        required
    />
  </div>
  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
    <Typography variant="subtitle1" component="div" sx={{ minWidth: 120 }}>
      Email Address <span style={{color: 'red'}}>*</span>
    </Typography>
    <TextField
      fullWidth
      label="Enter Email Id"
      variant="outlined"
      size="small"
        value={formData.EmailID || ''}
            onChange={(e) => setFormData({ ...formData, EmailID: e.target.value })}
       sx={{
    marginLeft: 2,
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px', // Add border radius
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ec008c', // Highlight border on focus
        boxShadow: '0 0 0 2px rgba(236,0,140,0.15)', // Optional: subtle glow
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '10px', // Ensure border radius on default
    },
  }}
        required
    />
  </div>
  {/* <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
    <Typography variant="subtitle1" component="div" sx={{ minWidth: 120 }}>
      User Id
    </Typography>
    <TextField
      fullWidth
      label="Enter Network Id"
      variant="outlined"
      size="small"
        value={formData.UserID || ''}
            onChange={(e) => setFormData({ ...formData, UserID: e.target.value })}
      sx={{ marginLeft: 2 }}
    />
  </div> */}
  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
    <Typography variant="subtitle1" component="div" sx={{ minWidth: 120 }}>
      Network Id
    </Typography>
    <TextField
      fullWidth
      label="Enter Network Id"
      variant="outlined"
      size="small"
        value={formData.NetworkID || ''}
            onChange={(e) => setFormData({ ...formData, NetworkID: e.target.value })}
       sx={{
    marginLeft: 2,
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px', // Add border radius
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ec008c', // Highlight border on focus
        boxShadow: '0 0 0 2px rgba(236,0,140,0.15)', // Optional: subtle glow
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '10px', // Ensure border radius on default
    },
  }}
    />
  </div>
  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
  <input
    type="checkbox"
    id="admin"
    style={{ marginRight: 8 }}
    checked={formData.AdminStatus === true}
    onChange={(e) => setFormData({ ...formData, AdminStatus: e.target.checked, 
        AdminValue: e.target.checked ? '1' : '0'
     })}
    
  />
  <label htmlFor="admin" style={{ fontSize: 16 }}>Admin</label>
</div>
</DialogContent>

      <DialogActions>
        <Button onClick={onClose}
        sx={{
          backgroundColor: '#ec008c',
          color: 'white',
          '&:hover': {
            backgroundColor: '#d5006d',
          },
  }}>Cancel</Button>
        <Button
      //    onClick={onConfirm}
          variant="contained"
           onClick={() => onConfirm(formData)}
          //color="primary"
        sx={{
            backgroundColor: '#ec008c',
            color: 'white',
            '&:hover': {
              backgroundColor: '#d5006d',
            },
          }}          
        //  disabled={disableConfirm || currentReason === ''}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ManageUserModal;
